import InputText from "@/components/common/InputText";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { KanbanColumn } from "smart-webcomponents-react";
import Plus from "@/assets/svg/Plus.svg";
import { KanbanColumnType } from "@/api/mutation/useKanbanCreateColumn";
import { useTranslation } from "react-i18next";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
export type footerData = {
  percentage: number | undefined;
  kanbanColumnId: string | undefined;
  taskName: string | undefined;
};

const FooterInput = (prop: {
  data: KanbanColumn;
  projectId: string | undefined;
  column: KanbanColumnType[] | undefined;
  callBack: (data: footerData) => void;
  projectRole?: keyof typeof UserRoleEnumValue
  isAdmin: boolean
  isProjectEditBlocked: boolean
  setIsProjectEditBlockedDialogOpen: (data: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [ToggleField, setToggleField] = useState(false);
  const [taskData, setTaskData] = useState<footerData>({
    percentage: undefined,
    kanbanColumnId: undefined,
    taskName: undefined,
  });
  useEffect(() => {
    const percentage = prop.column?.find(
      (c) => c.kanbanColumnId == prop.data.dataField
    )?.percentage;
    if (percentage) {
      setTaskData((prev) => ({
        ...prev,
        taskName: prev?.taskName,
        percentage: percentage,
        kanbanColumnId: prev?.kanbanColumnId,
      }));
    }
    setTaskData((prev) => ({
      ...prev,
      taskName: prev?.taskName,
      percentage: prev.percentage,
      kanbanColumnId: prop.data.dataField,
    }));
  }, [prop.column, prop.data.dataField]);

  return (
    <div className="select-none w-full">
      {ToggleField && (
        <div className="flex w-full justify-start flex-col gap-2 !bg-slate-5s0 rounded-lg">
          <InputText
            placeholder="create task"
            className="text-base py-1 mt-0 h-[36px]"
            onChange={(e) =>
              setTaskData((prev) => ({
                ...prev,
                taskName: e.target.value,
                persontage: prev?.percentage,
                kanbanColumnId: prev?.kanbanColumnId,
              }))
            }
            onKeyDown={(e) => {
              e.key == "Enter" ? prop.callBack(taskData) : "";
            }}
          />
          <div className="flex gap-2">
            <Button
              className=" w-1/2 ml-auto"
              variant={"destructive"}
              onClick={() => {
                if (prop.isProjectEditBlocked) {
                  prop.setIsProjectEditBlockedDialogOpen(true);
                  return;
                }
                setToggleField(true);
              }}
              size={"sm"}
            >
              {t("cancel")}
            </Button>
            <Button
              className="w-1/2 ml-auto gap-2"
              variant={"primary_outline"}
              size={"sm"}
              onClick={() => (taskData.taskName ? prop.callBack(taskData) : "")}
            >
              <img src={Plus} className="w-4 h-4 invert" alt="" />
              {t("add_task")}
            </Button>
          </div>
        </div>
      )}
      {!ToggleField && (
        <Button
          className="w-full justify-center text-white"
          variant={"primary"}
          onClick={() => {
            if (prop.isProjectEditBlocked) {
              prop.setIsProjectEditBlockedDialogOpen(true);
              return;
            }
            setToggleField(true);
          }}
          disabled={prop.isAdmin ? false : prop.projectRole && [UserRoleEnumValue.COLLABORATOR, UserRoleEnumValue.TEAM_MEMBER].includes(prop.projectRole as any)
          }
        >
          {t("add_task")}
        </Button>
      )}
    </div>
  );
};

export default FooterInput;
